export const langOptions: langOption[] = [
  {
    lang: 'EN',
    symbol: 'language_us',
    name: 'English',
  },
  {
    lang: 'ES',
    symbol: 'language_spanish',
    name: 'Español',
  },
];

export interface langOption {
  lang: string;
  symbol: string;
  name: string;
}
